const HECATE = 'BybitHecate';
const CDN_URL = '/common-static/infra-static/hecate/hecate.min.js';

let loadByJsHecatePromise: any = null;

export const loadJsHecateScript = async () => {
  if (loadByJsHecatePromise) {
    return loadByJsHecatePromise;
  }
  loadByJsHecatePromise = new Promise((resolve, reject) => {
    if (window[HECATE]) {
      resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.id = 'BybitHecate';
    script.src = CDN_URL;
    script.defer = true;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      loadByJsHecatePromise = null;
      reject();
    };
    document.body.appendChild(script);
  });

  return loadByJsHecatePromise;
};
